import * as React from 'react';

export const ModalFooter = (props: any) => <div className="modal-footer" {...props}>{props.children}</div>;



// WEBPACK FOOTER //
// ./src/components/Modal/ModalFooter.tsx